/*
 * THIS FILE WAS GENERATED BY "@atproto/lex". DO NOT EDIT.
 */

import { l } from '@atproto/lex'

const $nsid = 'app.bsky.embed.defs'

export { $nsid }

/** width:height represents an aspect ratio. It may be approximate, and may not correspond to absolute dimensions in any given unit. */
type AspectRatio = {
  $type?: 'app.bsky.embed.defs#aspectRatio'
  width: number
  height: number
}

export type { AspectRatio }

/** width:height represents an aspect ratio. It may be approximate, and may not correspond to absolute dimensions in any given unit. */
const aspectRatio = l.typedObject<AspectRatio>(
  $nsid,
  'aspectRatio',
  l.object({
    width: l.integer({ minimum: 1 }),
    height: l.integer({ minimum: 1 }),
  }),
)

export { aspectRatio }
